import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  DESTINATION_LABELS,
  LIVE_DESTINATIONS,
  SPORT_BY_ID,
} from "../constants/sportWorkspace";
import { useSportWorkspace } from "../hooks/useSportWorkspace";
import { getSportPath } from "../utils/sportWorkspace";
import { brandFilledButtonSx, brandOutlinedButtonSx } from "../utils/brandAssets";

const SportComingSoon = () => {
  const navigate = useNavigate();
  const { sport, destination, meta } = useSportWorkspace();
  const sportMeta = meta || SPORT_BY_ID[sport];
  const title = DESTINATION_LABELS[destination] || "This tool";
  const liveLinks = (LIVE_DESTINATIONS[sport] || []).filter(
    (id) => id !== destination
  );

  return (
    <Box sx={{ py: { xs: 1, sm: 2 }, maxWidth: 640, mx: "auto" }}>
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ letterSpacing: "0.16em" }}
      >
        stats.fan / {sportMeta.label}
      </Typography>
      <Typography variant="h3" component="h1" fontWeight={800} sx={{ mt: 0.5 }}>
        {title}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mt: 1.5, maxWidth: 520 }}
      >
        Same workspace as every other league — this {sportMeta.name.toLowerCase()}{" "}
        destination is next. Live {sportMeta.label} tools stay in the sidebar;
        everything else is marked Soon until it ships.
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mt: 3 }}>
        {liveLinks.slice(0, 3).map((id) => (
          <Button
            key={id}
            variant={id === "home" ? "contained" : "outlined"}
            onClick={() => navigate(getSportPath(sport, id))}
            sx={id === "home" ? brandFilledButtonSx : brandOutlinedButtonSx}
          >
            {id === "home" ? `${sportMeta.label} Home` : DESTINATION_LABELS[id]}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default SportComingSoon;
